
import RNDemo from '../RNDemo'
import RNDemoV2 from '../RNDemoV2'
import ComponentDemo from '../ComponentDemo'
import ImageUpload from '../ImageUpload'
import FooterBox from '../FooterBox'
import Scroller from '../Scroller'
import Post from '../Post'
import PostOld from '../PostOld'
import RNToH5Router from '../RNToH5Router'
import ContentBox from '../ContentBox'
import testCache1 from '../testCache1'
import testCache2 from '../testCache2'
import testCache3 from '../testCache3'
import testCache4 from '../testCache4'

let router = [
  {
    path: '/RNToH5Router',
    name: 'RNToH5Router',
    component: RNToH5Router,
    backPath:'',
    cnName:'RNToH5Router'
  },
  {
    path: '/RNDemo',
    name: 'RNDemo',
    component: RNDemo,
    backPath:'',
    cnName:'RNDemo'
  },
  {
    path: '/RNDemoV2',
    name: 'RNDemoV2',
    component: RNDemoV2,
    backPath:'',
    cnName:'RNDemoV2'
  },
  {
    path: '/ContentBox',
    name: 'ContentBox',
    component: ContentBox,
    backPath:'',
    cnName:'ContentBox'
  },
  {
    path: '/ComponentDemo',
    name: 'ComponentDemo',
    component: ComponentDemo,
    backPath:'',
    cnName:'ComponentDemo'
  },
  {
    path: '/ImageUpload',
    name: 'ImageUpload',
    component: ImageUpload,
    backPath:'',
    cnName:'ImageUpload'
  },
  {
    path: '/FooterBox',
    name: 'FooterBox',
    component: FooterBox,
    backPath:'',
    cnName:'FooterBox'
  },
  {
    path: '/Post',
    name: 'Post',
    component: Post,
    backPath:'',
    cnName:'Post'
  },
  {
    path: '/PostOld',
    name: 'PostOld',
    component: PostOld,
    backPath:'',
    cnName:'PostOld'
  },
  {
    path: '/Scroller',
    name: 'Scroller',
    component: Scroller,
    backPath:'',
    cnName:'Scroller'
  },
  
  {
    path: '/testCache1',
    name: 'testCache1',
    component: testCache1,
    backPath:'root',
    cnName:'testCache1',
    meta:{
      keepAlive: true,
    }
  },
  {
    path: '/testCache2',
    name: 'testCache2',
    component: testCache2,
    backPath:'',
    cnName:'testCache2',
    meta:{
      keepAlive: true,
    }
  },
  {
    path: '/testCache3',
    name: 'testCache3',
    component: testCache3,
    backPath:'',
    cnName:'testCache3',
    meta:{
      keepAlive: false,
    }
  },
  {
    path: '/testCache4',
    name: 'testCache4',
    component: testCache4,
    backPath:'',
    cnName:'testCache4'
  },
]


export default router


// WEBPACK FOOTER //
// ./src/page/demo/config/router.js